import {connect} from 'react-redux'
import DraftManagerSide from '../../components/manager_side/draft_manager_side_component'

export default connect()(DraftManagerSide)
